import React from 'react';
import './footer.scss';

var Footer = function Footer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("footer", {
    className: "footer"
  }, children);
};

export default Footer;